import axios, { AxiosResponse } from 'axios';
import qs from 'qs';

import { environment } from '../../environments/environment';
import { localeConfig } from '../config/locale.config';

export interface ApiClientResponse<T> extends AxiosResponse<T> {
  ok: boolean;
  response?: AxiosResponse<T>;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
}

export const apiClient = axios.create({
  responseType: 'json',
  baseURL: `${environment.protocol}://${localeConfig.host}`,
  withCredentials: true,
  paramsSerializer: (params) => qs.stringify(params),
});

apiClient.interceptors.request.use((config) => {
  config.headers.Authorization = `Basic ${environment.basicAuthToken}`;
  config.headers['Cache-Control'] = 'no-cache';
  return config;
});

apiClient.interceptors.response.use(
  (response) => normalizeSuccessResponse(response),
  (error) => normalizeErrorResponse(error),
);

function normalizeSuccessResponse<T>(response: AxiosResponse<T>): ApiClientResponse<T> {
  return {
    ...response,
    ok: true,
  };
}

function normalizeErrorResponse(error: any) {
  return {
    ...error,
    status: error?.response?.status,
    ok: false,
  };
}
